import React from "react";

export default () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.3333 2.66667H20V5.33333H16V2.66667H8V5.33333H4V2.66667H2.66667C1.19867 2.66667 0 3.86667 0 5.33333V21.3333C0 22.8 1.19867 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V5.33333C24 3.86667 22.8 2.66667 21.3333 2.66667ZM21.3333 21.3333H2.66667V10.6667H21.3333V21.3333ZM7.33333 0H4.66667V4.66667H7.33333V0ZM19.3333 0H16.6667V4.66667H19.3333V0Z"
                fill="black"
                fillOpacity="0.539261"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/components/CalendarIcon/CalendarIcon.tsx